module.exports = __webpack_public_path__ + "static/projekt_indywidualny_e10-0cb989f1ebe6de37ce333857c1359945.jpg";